import { createFeatureSelector, createSelector } from '@ngrx/store';
import { batchFeatureKey, BatchState } from '@batch/state/batch.reducer';

export const selectBatchState = createFeatureSelector<BatchState>(batchFeatureKey);

export const selectBatchFilters = createSelector(
  selectBatchState,
  (state) => state.tablePagination
);
